<div class="container-fluid">
        <h5>Release Details</h5>
        <form style="margin: 20px 0px;">
        <div class="row k-form-field">
            <label class="form-label k-label col-4" for="comment">Comment/Git Version Number</label>
            <div class="col-5">
            <label>{{release?.comment}}</label>
            
            </div>
        </div>
    
        <div class="row k-form-field">
            <label for="released_by_user_id" class="form-label k-label col-4">Released by User</label>
            <div class="col-5">
                <label>{{release?.released_by_user}}</label>
            
            </div>
        </div>
    
        <div class="row k-form-field">
            <label for="release_date" class="form-label k-label col-4">Release Date</label>
            <div class="col-5">
               <label>{{ release?.release_date | date:'dd/MM/yyyy' }}</label>
            
            </div>
        </div>
    </form>

    <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
    [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
    [pageSize]="pageSize" [pageable]="{
        buttonCount: buttonCount,
        previousNext: previousNext,
        info: info
    }" [height]="500">


    <kendo-grid-column field="title" title="Title" [width]="260" >
        <ng-template kendoGridCellTemplate let-dataItem>
        <div [innerHTML]="formatTextLink(dataItem.title, dataItem.id)"></div>
        </ng-template>
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
        <div
            [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
            , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1 
            , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
            , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
            {{dataItem.user_story_priority_description}}
        </div>
        </ng-template>
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="user_story_type_description" title="Type" [width]="120" >
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="owned_by_users" title="Owners" [width]="120" >
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="requested_by_user" title="Requested By" [width]="150" >
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="user_story_estimate_description" title="Estimate" [width]="100">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
    </kendo-grid-column>

    </kendo-grid>
    <button kendoButton (click)="onClose()" class="btn btn-primary btn-right">Close</button>
</div>